import styled from 'styled-components';

import variables from '../../../styles/variables';
import diagonalLines from '../../../images/diagonalLines.svg';

export const PreHeaderBar = styled.div<{colour: string;}>`
  width: 100%;
  background-color: ${(props) => props.colour};
  background-image: url(${diagonalLines});
  background-size: cover;
  color: black;
  padding: 12px 0;
  text-align: center;
  &.hide {
    display: none;
  }
  @media screen and (max-width: 1023px) {
    margin-bottom: 6px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  margin: auto;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  @media screen and (max-width: 1023px) {
    max-width: ${variables.mobileWidth}px;
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
`;

export const LinkWrapper = styled.div`
  margin: auto;
  display: inline-block;
  justify-self: center;
  p {
    margin-bottom: 0;
  }
  a {
    font-weight: bold;
  }
`;

export const CloseButton = styled.button`
  justify-self: flex-end;
  background: none;
  border: none;
  &:hover {
    cursor: pointer;
  }
`;
